<template>
  <div>
    <div class="white-container" :key="$store.getters['resource/currentResource'].key">
      <loader v-if="loading" :styleObject="{height: '160px!important'}"/>

      <triggers-view @save="saveEvent"
                     :prefillParams="prefillParams"
                     v-if="prefillParams"/>
    </div>
  </div>
</template>

<script>
  import TriggersView from "./TriggersView.vue";

  export default {
    components: {
      TriggersView
    },
    middleware: 'auth',
    name: 'TriggersEditing',
    data () {
      return {
        prefillParams: null,
        loading: false
      }
    },
    computed: {
      id () {
        return this.$route.params.id || ''
      }
    },
    mounted () {
      if(!this.id){
        this.$router.push({path: '/triggers'})
      } else {
        this.loading = true;
        this.getData(`triggers/handlers/${this.id}`, null, true).then(response => {
          if (response.data) {
            this.prefillParams = response.data;
          }
        }).finally(() => this.loading = false);
      }
    },
    methods: {
      saveEvent(params) {
        this.putData(`triggers/handlers/${this.id}`, params, '/triggers');
      }
    }
  }
</script>